import { Component, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { Observable, Subject } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import { SENTREX_LOGO } from '../../providers/images';
import { Storage } from '@ionic/storage';
import { PdfProvider } from '../../providers/pdf/pdf';

@IonicPage()
@Component({
  selector: 'page-clinic-supplies-default',
  templateUrl: 'clinic-supplies-default.html',
})
export class ClinicSuppliesDefaultPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  public supplyview = 'order';
  public clinic: any = {};
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  suppliesList: any[];
  supplistOrderList: any;
  public doctorList: Observable<any[]>;
  category_previous: string;
  doctor: any;
  task: AngularFireUploadTask;
  public order: any = {};
  filepath: any;
  notes: string;
  primarylocation: any = {};
  location: any = null;

 constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    private storage: Storage,
    private afStorage: AngularFireStorage,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public zone: NgZone,
    private pdf: PdfProvider
    ) {


    this.clinic['locations'] = [];
    this.clinic.address = {};
      this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;
      
      this.database.getClinic(this.clinic_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
        this.primarylocation.name = 'Primary Location'
        this.primarylocation.address = this.clinic.address.address;
        this.primarylocation.city = this.clinic.address.city
        this.primarylocation.phone_number = '';
      }
      this.location = this.primarylocation;
    });

    this.database
    .getSupplyByClinic(this.clinic_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        if(a.payload.doc.data()['clinics_default']) {
          data.default = (a.payload.doc.data()['clinics_default'].includes(this.clinic_id));
          // data.default = (a.payload.doc.data()['clinics_default'].includes(this.clinic_id));
        }
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((supplies) => {
      this.suppliesList = supplies;
      this.supplistOrderList = JSON.parse(JSON.stringify(supplies));
    });
  });
}


  ngOnDestroy() {
    console.log('Leave supplies page and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  showDivider(category: string) {
    if (category !== this.category_previous) {
      this.category_previous = category;
      return true;
    } else {
      this.category_previous = category;
      return false;
    }
    
  }

  checkToggled(clinics) {
    if(clinics) {
      return (clinics.includes(this.clinic_id));
    } else {
      return false;
    }
  }

  updateSuppliesDefault(ev, supply) {
    if (ev.value) {
      if(supply.clinics_default) {
        supply.clinics_default.push(this.clinic_id);
      }
      else {
        supply['clinics_default'] = [];
        supply.clinics_default.push(this.clinic_id);
      }
    } else {
      if(supply.clinics_default)  {
        const index: number = supply.clinics_default.indexOf(this.clinic_id, 0);
        if (index > -1) {
          supply.clinics_default.splice(index, 1);
       }
      }
    }
    this.database.updateSupply(supply)
    .then(()=>{})
    .catch((err) => {});
  }


}



// WEBPACK FOOTER //
// ./src/pages/clinic-supplies-default/clinic-supplies-default.ts